import type { Router } from 'vue-router';
import { websocketOpts } from 'vue-native-websocket-vue3/dist/lib/type/pluginsType';

export const globals = {} as {
    $connect: (connectionUrl?: string, connectionOpts?: websocketOpts) => void;
    $disconnect: () => void;
    $socket: WebSocket;
    router: Router;
};
